import React, { useEffect } from 'react';
import Layout from '../components/layout';
import UsefulDocuments from '../components/useful-documents/useful-documents.component';

import '../styles/app.scss';
import {useLocation} from "@reach/router";
import {triggerTealiumEvent} from "../utils/tealiumUtils";

const StandAloneResources = () => {
  const location = useLocation();

  if (typeof window !== "undefined" && window.utag) {
    triggerTealiumEvent({
      tealiumEvent: "view",
      pageUrl: location.href,
      pageName: "resources",
      pageType: "product information",
      pageSubCategory: "resources",
      pageCategory: location,
      rawDataLayer: "10451v48",
    });
  }

  return (
    <Layout
      title="Resources"
      metaDescription="To help you find what you\'re looking for, we've grouped our lending criteria into key categories. You can browse by category or use the search function to jump straight to the relevant entry."
    >
      <section className="page-section row center-xs">
        <div className="col-xs-12 col-md-6 col-lg-5 col-xl-4 margin-bottom-double">
          <h1 className="page-title page-title--small page-title--resource">Useful documents</h1>
          <section className="splitted-section">
            <UsefulDocuments />
          </section>
        </div>
      </section>
    </Layout>
  );
};
export default StandAloneResources;
